import permissions from "app/permissions";
import { ACADEMIC_REQUESTS, StudentServicePath } from "utils/constants";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import ListAcademicRequests from "./List";
import { resources as DataIssues } from "./DataIssues";
import { tenants } from "utils/tenants";

// The parent only carries the menu label and permission — a resource with `subMenu` never becomes a
// <Resource>, so the list below must stay registered as a child to keep /student/academic-requests alive.
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <PlaylistAddCheckCircleIcon />,
  name: StudentServicePath + ACADEMIC_REQUESTS,
  title: "Академични заявки",
  permission: permissions.canPreviewAcademicRequests,
  subMenu: [
    {
      isMenu: true,
      icon: <DescriptionIcon />,
      name: StudentServicePath + ACADEMIC_REQUESTS,
      title: "Академични заявки",
      list: <ListAcademicRequests />,
      permission: permissions.canPreviewAcademicRequests,
    },
    DataIssues,
  ],
};
